export default __webpack_public_path__ + "static/media/shop-integrations.a5701de5.svg";